import React from 'react';
import "./BindPhoneModal.less";
import Button from 'antd/lib/button';
import {Form, Input, Modal} from "antd"
import TankComponent from "../../../common/component/TankComponent";
import User from "../../../common/model/user/User";
import Moon from "../../../common/model/global/Moon";
import Lang from "../../../common/model/global/Lang";
import MessageBoxUtil from '../../../common/util/MessageBoxUtil';
import { NumberOutlined, PhoneFilled } from '@ant-design/icons';
import Sun from '../../../common/model/global/Sun';

interface IProps {
  user: User
  onSuccess: () => void
  onClose: () => void
}

interface IState {
  phone: string
}

export default class BindPhoneModal extends TankComponent<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      phone: ""
    };
  }

  componentDidMount() {

  }

  static open(user: User, onSuccess: () => void) {

    let modal = Modal.success({
      okCancel: false,
      okButtonProps: {
        className: "display-none"
      },
      icon: null,
      content: <BindPhoneModal
        user={user}
        onSuccess={() => {
          modal.destroy()
          onSuccess()
        }}
        onClose={() => {
          modal.destroy()
        }}/>,
    })

  }


  onFinish(values: any) {


    let that = this

    let currentUser: User = this.props.user

    currentUser.httpBindPhone(values["phone"], values["phonecode"], function () {
      that.props.onSuccess()
      window.location.reload()
    })

  };

  onFinishFailed(errorInfo: any) {

  };

  onGetCode() {
    let that = this
    let currentUser: User = this.props.user
    const {phone} = this.state

    currentUser.httpBindPhoneCode(phone, function () {
      MessageBoxUtil.success(Lang.t("user.codeSuccess"))
    })
  }

  setPhone(e: any) {
    let value = e.target.value
    this.setState({
      phone: value
    })
  }


  render() {

    let that = this
    let currentUser: User = this.props.user
    const {phone} = this.state

    const layout = {
      labelCol: {span: 8},
      wrapperCol: {span: 16},
    };
    const tailLayout = {
      wrapperCol: {offset: 8, span: 16},
    };

    return (
      <div className="widget-single-text-modal">

        <div className="text-center">
          <h2>
            {Lang.t("user.bind")}
          </h2>
        </div>

        <Form
          {...layout}
          name="basic"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed.bind(this)}
        >
          <Form.Item
            label={Lang.t("user.phone")}
            name="phone"
            rules={[{required: true, message: Lang.t("user.enterPhone")}]}
          >
            <Input value={phone} onChange={(e)=>{this.setPhone(e)}} placeholder={Lang.t("user.enterPhone")} prefix={<PhoneFilled/>}/>
          </Form.Item>
          <div className="getbindphonecode" onClick={this.onGetCode.bind(this)}>{Lang.t("user.getPhonecode")}</div>

          <Form.Item
            label={Lang.t("user.phonecode")}
            name="phonecode"
            rules={[{required: true, message: Lang.t("user.enterPhonecode")}]}
          >
            <Input placeholder={Lang.t("user.enterPhonecode")} prefix={<NumberOutlined/>}/>
          </Form.Item>


          <Form.Item {...tailLayout}>

            <Button className="ml20" type="default" onClick={() => {
              this.props.onClose()
            }}>{Lang.t("close")}</Button>

            <Button className="ml20"
                    type="primary" htmlType="submit">{Lang.t("submit")}</Button>

          </Form.Item>

        </Form>


      </div>
    );
  }
}




